import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'redux'
import {
  alertSelector,
  notificationsSelector
} from '../../store/selectors/alertSelectors'
import { dismissAlert, dismissNotification } from '../../store/actions/alerts'
import Shortcuts from '../../containers/Shortcuts'
import { branch, renderNothing } from 'recompose'

export default compose(
  connect(
    state => ({
      alert: alertSelector(state),
      notifications: notificationsSelector(state)
    }),
    {
      dismiss: dismissAlert,
      dismissNotification: dismissNotification
    }
  ),
  branch(
    ({ alert, notifications = [] }) => !alert && !notifications.length,
    renderNothing
  ),
  Shortcuts('ALERT', ({ alert, dismiss }) => (action, event) => {
    switch (action) {
      case 'CONFIRM':
        alert.actions && alert.actions.length && alert.actions[0].action(event)
        dismiss()
        event.preventDefault()
        break
      case 'CANCEL':
        alert.dismiss && dismiss()
        event.preventDefault()
        break
      default:
    }
  }),
  withTranslation()
)
